<template>
  <v-container px-0 py-0 mx-0 my-0 fluid>
    <div class="top-img">
      <v-img :src="require('../assets/home-main-img.png')" class="top-img-contents" position="bottom center" cover="true"></v-img>
    </div>
    <!-- div class="for-biginners"><v-btn color="white darken-1" outline round to="/forbiginners">{{$t("forbiginners")}}</v-btn></div -->
    <v-container grid-list-lg>
      <h1 class="ss-headline">Contents</h1>
      <v-layout row wrap class="ss-layout">
        <v-flex xs12 sm6>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="1/1">
              <router-link to="/category/kanji"><v-img :src="require('../assets/kanji.png')" aspect-ratio="1.33" class="ss-card-img"></v-img></router-link>
              <div class="ss-card-title">kanji</div>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="1/1">
              <router-link to="/category/katakana"><v-img :src="require('../assets/katakana.png')" aspect-ratio="1.33" class="ss-card-img"></v-img></router-link>
              <div class="ss-card-title">katakana</div>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="1/1">
              <router-link to="/category/hiragana"><v-img :src="require('../assets/hiragana.png')" aspect-ratio="1.33" class="ss-card-img"></v-img></router-link>
              <div class="ss-card-title">hiragana</div>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="1/1">
              <router-link to="/category/english"><v-img :src="require('../assets/english.png')" aspect-ratio="1.33" class="ss-card-img"></v-img></router-link>
              <div class="ss-card-title">english</div>
            </v-responsive>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <h1 class="ss-headline">Service</h1>
      <v-layout row wrap class="ss-layout">
        <v-flex xs12 sm4>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="3/4">
              <v-img :src="require('../assets/original.png')" aspect-ratio="1" contain="true" class="ss-card-img"></v-img>
              <div class="ss-card-title2">original order</div>
              <div class="subheading">{{ $t("original-order-text") }}</div>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="3/4">
              <v-img :src="require('../assets/name.png')" aspect-ratio="1" contain="true" class="ss-card-img"></v-img>
              <div class="ss-card-title2">The Japanese name</div>
              <div class="subheading">{{ $t("japanese-name-text") }}</div>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card class="ss-card">
            <v-responsive :aspect-ratio="3/4">
              <v-img :src="require('../assets/request.png')" aspect-ratio="1" contain="true" class="ss-card-img"></v-img>
              <div class="ss-card-title2">request order</div>
              <div class="subheading">{{ $t("request-order-text") }}</div>
            </v-responsive>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <h1 class="ss-headline">About</h1>
      <div class="title mb-3">{{ $t("what-is-samuraistock") }}</div>
      <div class="subheading">{{ $t("about-body") }}</div>
    </v-container>
  </v-container>
</template>

<style>
.top-img {
  background: #FFFFFF url(../assets/home-main-bg.png) no-repeat;
  background-size: cover;
  text-align: center;
}

.top-img-contents {
  height: 55vw;
}

.for-biginners {
  background-color: #888888;
  text-align: center;
  height: 50px;
  font-size: 20px;
  color: #FFFFFF;
}

.ss-headline {
  font-family: myriad-pro, sans-serif;
  font-weight: 700;
  font-style: italic;
  font-size: 48px;
  color: #E53341;
  border-bottom: #E53341 2px dotted;
  display: inline-block;
  line-height: 1;
  margin-top: 40px;
  margin-bottom: 20px;
}

.ss-layout {
  margin-bottom: 40px !important;
}

.ss-card {
  padding: 10px;
}

.ss-card-img {
  margin-bottom: 10px;
}

.ss-card-title {
  font-family: myriad-pro, sans-serif;
  font-weight: 700;
  font-style: normal;
  text-align: center;
  background-color: #EFEFEF;
  font-size: 60px;
}

.ss-card-title2 {
  font-family: myriad-pro, sans-serif;
  font-weight: 700;
  font-style: normal;
  text-align: center;
  background-color: #EFEFEF;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 10px;
}

.contents-box {
  height: 200px;
  border: #AAAAAA 1px solid;
}

.body-1,
.subheading {
  white-space: pre-wrap;
}

@media only screen and (max-width: 1903px) {
  .ss-headline {
    font-size: 48px;
  }
  .top-img-contents {
    height: 55vw;
  }
}

@media only screen and (max-width: 1263px) {
  .ss-headline {
    font-size: 40px;
  }
  .top-img-contents {
    height: 65vw;
  }
}

@media only screen and (max-width: 959px) {
  .ss-headline {
    font-size: 32px;
  }
  .top-img-contents {
    height: 80vw;
  }
}

@media only screen and (max-width: 599px) {
  .ss-headline {
    font-size: 24px;
  }
  .top-img {
    height: 80vh;
    padding-top: calc((80vh - 90vw) / 2);
  }
  .top-img-contents {
    height: 90vw;
  }
}

</style>

<script>
  export default {
    created() {
      this.$emit('getAuth');
    },
  }
</script>
